module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('nav', {
    staticClass: "c-nav"
  }, [_c('div', {
    staticClass: "c-nav__left"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "c-nav__menu",
    class: _vm.displayClose
  }, [_c('div', {
    staticClass: "c-nav__item s--about"
  }, [_c('span', {
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.toggleAboutDisplay($event)
      }
    }
  }, [_vm._v("about me")])]), _vm._v(" "), _vm._m(1), _vm._v(" "), _vm._m(2), _vm._v(" "), _vm._m(3), _vm._v(" "), _vm._m(4), _vm._v(" "), _c('div', {
    staticClass: "c-nav__item s--close"
  }, [_c('span', {
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.toggleAboutDisplay($event)
      }
    }
  }, [_vm._v("close")])])])]), _vm._v(" "), _c('div', {
    staticClass: "c-nav__right"
  }, [_c('div', {
    staticClass: "c-nav__index",
    class: _vm.displayClose
  }, _vm._l((_vm.projects), function(project) {
    return _c('span', {
      class: {
        's--active': project.key === _vm.currentIndex
      }
    })
  }))])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "c-nav__logo"
  }, [_c('h1', [_vm._v("Théo Kleman")]), _vm._v(" "), _c('span', [_vm._v("another developer")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "c-nav__item"
  }, [_c('a', {
    attrs: {
      "target": "_blank",
      "href": "https://twitter.com/Theo_KlMan"
    }
  }, [_vm._v("twitter")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "c-nav__item"
  }, [_c('a', {
    attrs: {
      "target": "_blank",
      "href": "https://fr.linkedin.com/in/theokleman"
    }
  }, [_vm._v("linkedin")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "c-nav__item"
  }, [_c('a', {
    attrs: {
      "target": "_blank",
      "href": "https://github.com/TheoKleman/"
    }
  }, [_vm._v("github")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "c-nav__item"
  }, [_c('a', {
    attrs: {
      "target": "_blank",
      "href": "http://codepen.io/theElkman/"
    }
  }, [_vm._v("codepen")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-eca55338!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Navbar/Navbar.vue
// module id = 92
// module chunks = 2